import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Paragraph } from '../title';

const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;

const BestSeller = ({ allblog }) => {
    const navigate = useNavigate();

    const handleDetailsRow = (id) => {
        navigate(`/shop/${id}`);
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <table className='w-full my-2'>
            <tbody>
                {allblog?.slice(0, 3).map((row, index) => {
                    const displayCount = row.purchase_count && row.purchase_count > 0
                        ? row.purchase_count
                        : 10;

                    return (
                        <tr
                            className='border-b cursor-pointer hover:bg-gray-50 transition'
                            key={index}
                            onClick={() => handleDetailsRow(row.id)}
                        >
                            <td className='py-2 w-1/3 rounded-lg'>
                                <img
                                    src={BASE_IMAGE_URL + row.image}
                                    alt={row.name}
                                    className="h-[70px] w-[70px] object-cover rounded-lg shadow hover:scale-110 transition-transform duration-300"
                                />
                            </td>

                            <td className='py-2 pl-4 text-right align-middle'>
                                <h2 className="text-[#00A762] text-base font-medium capitalize">
                                    {row.name}
                                </h2>
                                <Paragraph title={`${displayCount} purchases`} textAlign="right" />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default BestSeller;